/* Keep checkout a native Shopify POST; only enhance cart updates. */
(function () {
  'use strict';
  var timer, busy = false;
  function page() { return document.querySelector('[data-cart-page]'); }
  function clearTimer() { window.clearTimeout(timer); timer = null; }
  function update(focusKey) {
    clearTimer();
    var root = page(), form = root && root.querySelector('#cart-form');
    if (!form || busy || !form.reportValidity()) return;
    var data = new FormData(form);
    data.append('sections', root.dataset.sectionId);
    data.append('sections_url', window.location.pathname);
    var controls = Array.from(form.querySelectorAll('button,input,textarea'));
    var previous = controls.map(function (control) { return control.disabled; });
    busy = true;
    root.setAttribute('aria-busy', 'true');
    root.querySelector('[data-cart-error]').hidden = true;
    root.querySelector('[data-cart-status]').textContent = 'Updating your cart…';
    controls.forEach(function (control) { control.disabled = true; });
    var accelerated = root.querySelector('[data-cart-accelerated]');
    if (accelerated) accelerated.hidden = true;
    var url = new URL(form.action, window.location.href);
    url.pathname = url.pathname.replace(/\/$/, '') + '/update.js';
    url.search = '';
    fetch(url.href, {method:'POST', body:data, headers:{Accept:'application/json'}})
      .then(function (response) {
        return response.json().then(function (cart) {
          if (!response.ok || cart.errors) throw new Error(typeof cart.description === 'string' ? cart.description : 'Unable to update your cart. Please check the quantities and try again.');
          return cart;
        });
      })
      .then(function (cart) {
        var html = cart.sections && cart.sections[root.dataset.sectionId];
        var fresh = html && new DOMParser().parseFromString(html, 'text/html').querySelector('[data-cart-page]');
        if (!fresh) { window.location.reload(); return; }
        root.replaceWith(fresh);
        document.querySelectorAll('[data-cart-count],.header__cart-count').forEach(function (count) {
          count.textContent = cart.item_count;
          if (count.classList.contains('header__cart-count')) count.style.display = cart.item_count ? '' : 'none';
        });
        fresh.querySelector('[data-cart-status]').textContent = cart.item_count ? 'Cart updated.' : 'Your cart is now empty.';
        var line = Array.from(fresh.querySelectorAll('[data-line-key]')).find(function (row) { return row.dataset.lineKey === focusKey; });
        var target = focusKey === 'note' ? fresh.querySelector('[name="note"]') : line && line.querySelector('[data-qty-input]');
        if (!target) target = fresh.querySelector('h1');
        if (target) { if (target.tagName === 'H1') target.tabIndex = -1; target.focus({preventScroll:true}); }
      })
      .catch(function (error) {
        root.querySelector('[data-cart-status]').textContent = '';
        var message = root.querySelector('[data-cart-error]');
        message.textContent = error.message || 'Unable to update your cart. Please try again.';
        message.hidden = false;
        // Native checkout still submits current quantities and note to Shopify.
      })
      .finally(function () {
        busy = false;
        root.removeAttribute('aria-busy');
        controls.forEach(function (control, index) { control.disabled = previous[index]; });
      });
  }
  document.addEventListener('change', function (event) {
    var root = page();
    if (!root || !root.contains(event.target) || !event.target.matches('[name="updates[]"],[name="note"]')) return;
    clearTimer();
    var accelerated = root.querySelector('[data-cart-accelerated]');
    if (accelerated) accelerated.hidden = true;
    var row = event.target.closest('[data-line-key]');
    var key = row ? row.dataset.lineKey : 'note';
    timer = window.setTimeout(function () { update(key); }, 350);
  });
  document.addEventListener('click', function (event) {
    var remove = event.target.closest('[data-page-remove]');
    if (!remove || !remove.closest('[data-cart-page]')) return;
    event.preventDefault();
    if (busy) return;
    var row = remove.closest('[data-line-key]');
    row.querySelector('[name="updates[]"]').value = '0';
    update(row.dataset.lineKey);
  });
  document.addEventListener('submit', function (event) {
    if (!event.target.matches('[data-cart-page] #cart-form')) return;
    clearTimer();
    if (busy) { event.preventDefault(); return; }
    if (event.submitter && event.submitter.name === 'checkout') return;
    event.preventDefault();
    update();
  });
})();
